import { FilterTypes } from '../../../../modules/sortAndFilter/workers/sortAndFilter';
import Filter from './Filter';

class ProductTypeFilter extends Filter<boolean> {
    constructor(type: FilterTypes['type'], urlKey: string) {
        super(type, urlKey);
        this.setKeysFromUrl();
    }

    formatTagLabel = () => 'Over the Counter';
    formatKeysFromUrl = () => [true];
}

export default ProductTypeFilter;
